import {defineStore} from "pinia";

export const usePaySlipStore = defineStore('paySlip', {
    state: () => ({
        paySlip: {
            details: [],
            files: [],
        },
        paySlips: [],
        loading: false,
        refresh: null,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setRefresh() {
            const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let randomString = '';
            for (let i = 0; i < 10; i++) {
                const randomIndex = Math.floor(Math.random() * charset.length);
                randomString += charset[randomIndex];
            }
            this.refresh = randomString;
        },
        setPaySlip(paySlip) {
            this.paySlip = paySlip
        },
        setPaySlips(paySlips) {
            this.paySlips = paySlips
        },
        addPaySlip(paySlip) {
            this.paySlips.unshift(paySlip)
        },
        updatePaySlip(paySlip) {
            this.paySlip = paySlip;
            let index = this.paySlips.findIndex(cl => cl.id === paySlip.id)
            if (index !== -1)
                this.paySlips.splice(index, 1, paySlip)
        },
        updatePaySlipByWorkerId(paySlip) {
            this.paySlip = paySlip;
            let index = this.paySlips.findIndex(cl => cl.workerId === paySlip.workerId)
            if (index !== -1)
                this.paySlips.splice(index, 1, paySlip)
        },
        addAll(paySlips) {
            paySlips.forEach(paySlip => this.addPaySlip(paySlip));
        },
        updateAll(paySlips) {
            paySlips.forEach(paySlip => this.updatePaySlip(paySlip));
        },
        deletePaySlip(paySlip) {
            let index = this.paySlips.findIndex(cl => cl.id === paySlip.id)
            this.paySlips.splice(index, 1)
        },
    },
});